import { render, staticRenderFns } from "./InputCpf.vue?vue&type=template&id=7c968779&scoped=true"
import script from "./InputCpf.vue?vue&type=script&lang=js"
export * from "./InputCpf.vue?vue&type=script&lang=js"
import style0 from "./InputCpf.vue?vue&type=style&index=0&id=7c968779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c968779",
  null
  
)

export default component.exports